export const Phone = ({ ...props }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 2.5C17.5 2.5 20.25 2.75 23.75 6.25C27.25 9.75 27.5 12.5 27.5 12.5"
        stroke="#0C9015"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.7588 6.91943C17.7588 6.91943 18.9962 7.27299 20.8524 9.12914C22.7085 10.9853 23.0621 12.2227 23.0621 12.2227"
        stroke="#0C9015"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.547 6.64521L13.3583 8.09888C14.0904 9.41073 13.7965 11.1317 12.6434 12.2847C12.6434 12.2848 12.6434 12.2848 12.6434 12.2848C12.6433 12.2849 11.2448 13.6835 13.7806 16.2194C16.3158 18.7545 17.7144 17.3574 17.7152 17.3566C17.7153 17.3566 17.7153 17.3566 17.7153 17.3566C18.8684 16.2035 20.5893 15.9096 21.9011 16.6417L23.3548 17.453C25.3357 18.5585 25.5696 21.3366 23.8285 23.0777C22.7822 24.124 21.5005 24.9381 20.0836 24.9918C17.6985 25.0822 13.6478 24.4786 9.58463 20.4154C5.52141 16.3521 4.91777 12.3015 5.00819 9.91636C5.0619 8.4995 5.876 7.21779 6.92226 6.17154C8.66344 4.43035 11.4415 4.6643 12.547 6.64521Z"
        stroke="#0C9015"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
